import { getOwner } from '@ember/application';
import Service from '@ember/service';
import type Uploader from 'garaje/utils/uploader';
/*
  Temporary class so we can use dependency injection to share the uploader
  between engines, until we can refactor the uploader to just upload into
  the browser and move the call to the server to the store/adapter where it
  belongs
*/
export default class UploaderFactoryService extends Service {
  createUploader(args: Partial<unknown> | undefined): Uploader {
    return <Uploader>getOwner(this).factoryFor('util:uploader')?.create(args);
  }
}
